import React from 'react';
import { Text } from '@billda/design-system';
import type { ReimportSummary } from '../../types/reimportTypes';

interface ReimportSummaryTilesProps {
  summary: ReimportSummary;
}

const formatMoney = (value: number): string => {
  return `£${value.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const ReimportSummaryTiles: React.FC<ReimportSummaryTilesProps> = ({
  summary,
}) => {
  const allTiles = [
    {
      value: summary.plotsAdded,
      display: `+${summary.plotsAdded}`,
      label: 'plots added',
      colorClass: 'text-content-success',
    },
    {
      value: summary.plotsRemoved,
      display: `-${summary.plotsRemoved}`,
      label: 'plots removed',
      colorClass: 'text-content-error',
    },
    {
      value: summary.labourItemsAdded,
      display: `+${summary.labourItemsAdded}`,
      label: 'items added',
      colorClass: 'text-content-success',
    },
    {
      value: summary.labourItemsRemoved,
      display: `-${summary.labourItemsRemoved}`,
      label: 'items removed',
      colorClass: 'text-content-error',
    },
    {
      value: summary.labourItemsPriceChanged,
      display: summary.labourItemsPriceChanged.toString(),
      label:
        summary.labourItemsPriceChanged === 1
          ? 'pricing change'
          : 'pricing changes',
      colorClass: 'text-content-warning',
    },
    {
      value: summary.moneyAdded,
      display: `+${formatMoney(summary.moneyAdded)}`,
      label: 'value increase',
      colorClass: 'text-content-success',
    },
    {
      value: summary.moneyRemoved,
      display: `-${formatMoney(summary.moneyRemoved)}`,
      label: 'value decrease',
      colorClass: 'text-content-error',
    },
  ];

  const visibleTiles = allTiles.filter(tile => tile.value > 0);

  if (visibleTiles.length === 0) {
    return null;
  }

  return (
    <div
      className="flex flex-wrap gap-x-6 gap-y-2"
      data-testid="reimport-summary-tiles"
    >
      {visibleTiles.map(tile => (
        <div key={tile.label} className="flex items-baseline gap-1.5">
          <Text
            variant="body2"
            className={`font-semibold tabular-nums ${tile.colorClass}`}
          >
            {tile.display}
          </Text>
          <Text variant="caption" color="secondary">
            {tile.label}
          </Text>
        </div>
      ))}
    </div>
  );
};

export default ReimportSummaryTiles;
